import { useLayoutEffect } from 'react';

export default function PartnerTheme() {
  useLayoutEffect(() => {
    const previous = document.body.getAttribute('data-app-theme');
    document.body.setAttribute('data-app-theme', 'partner');
    return () => {
      if (previous === null) document.body.removeAttribute('data-app-theme');
      else document.body.setAttribute('data-app-theme', previous);
    };
  }, []);
  return null;
}
